var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.79607 34.446L8.79605 34.946H9.29607H34.9471H35.4471V34.446V8.79706V8.29706H34.9471H9.29707H8.79709L8.79707 8.79704L8.79607 34.446ZM8.79607 88.5981L8.79605 89.0981H9.29607H34.9471H35.4471V88.5981V62.9471V62.4471H34.9471H9.29707H8.79709L8.79707 62.9471L8.79607 88.5981ZM62.9471 34.4471V34.9471H63.4471H89.0961H89.5961V34.4471V8.79706V8.29706H89.0961H63.4471H62.9471V8.79706V34.4471ZM87.4561 65.5861H97.1471V75.2731H87.4561V65.5861ZM86.4561 76.2731V85.9601H76.7691V76.2731H76.7711H86.4561ZM76.7711 64.5861H76.7691V54.899H86.4561V64.5861H76.7711ZM75.7711 65.5861V75.2731H75.7691H66.0841V65.5861H75.7691H75.7711ZM75.7691 86.9601V96.6471H66.0821V86.9601H66.0841H75.7691ZM65.0841 85.9601H65.0821H55.3971V76.2731H65.0841V85.9601ZM65.0841 64.5861H55.3971V54.899H65.0841V64.5861ZM87.4581 96.6471V86.9601H97.1471V96.6471H87.4581ZM1.24707 42.495V0.74707H42.9941V42.4941L1.24707 42.495ZM1.24707 96.6471V54.9001H42.9941V96.6471H1.24707ZM55.3961 42.498V0.74707H97.1471V42.4941L55.3961 42.498Z",
    fill: "url(#paint0_linear_1_2522)",
    stroke: "url(#paint1_linear_1_2522)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2522",
    x1: 0.74707,
    y1: 48.6971,
    x2: 97.6471,
    y2: 48.6971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5a31ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f69ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2522",
    x1: 0.74707,
    y1: 48.6971,
    x2: 97.6471,
    y2: 48.6971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5a31ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f69ec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/qr-code-icon.84b7767be77b0533796cc8e620258a47.svg";
export { ForwardRef as ReactComponent };